import Vuex from 'vuex';
import Vue from 'vue';
import { TRANSACTIONS_NAMESPACE, transactions } from './modules/transactions/transactions.store.js';

var _a;
Vue.use(Vuex);
var store = new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    modules: (_a = {},
        _a[TRANSACTIONS_NAMESPACE] = transactions,
        _a),
});

export { store };
